import { PageBreadcrumbItem } from 'components/common/PageBreadcrumb';

export const ndsBreadcrumbItems: PageBreadcrumbItem[] = [
  {
    label: 'directories',
    url: '/directories/stock'
  },
  {
    label: 'vat',
    active: true
  }
];

export type NDSType = {
  country: string;
  nds: string;
  status: string;
};
